module.exports = __webpack_public_path__ + "img/eco_naked.17247bb8.svg";